import React from 'react'
import { FloatLabel } from 'primereact/floatlabel'
import { Dropdown, DropdownProps } from 'primereact/dropdown'

export type EditableDropdownProps = DropdownProps & {
  label: string
  errors: string | undefined
  containerClass?: string
}

const omit = <a,ks>(x:a,...ks:(keyof a)[]) : Partial<a> => {
  const temp = { ...x }
  ks.forEach((k) => {
    delete temp[k]
  })
  return temp
}

export const EditableDropdown : React.FC<EditableDropdownProps> = (props) => {
  return (
    <div className={props.containerClass ?? 'w-50'}>
      <FloatLabel>
        <Dropdown
          {...omit(props,'containerClass')}
        />
        <label htmlFor={props.id}>{props.label}</label>
      </FloatLabel>
        {!!props.errors &&
          <small id={props.id + '-error'} className="text-danger">
            {props.errors}
        </small>}
    </div>
  )
}
